import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import { Grid, Typography, List, ListItem } from '@mui/material';
import { withTranslation } from 'react-i18next';
import ReceiveMethodEnum from '../../enums/ReceiveMethodEnum';
import CurrencyDisplay from '../common/CurrencyDisplay';

@inject('menuStore', 'cartStore', 'userStore', 'orderStore')
@observer
class LiteMenuList extends Component {
  render() {
    const { t, menuStore, cartStore, userStore, orderStore } = this.props;
    return (
      <React.Fragment>
        <div className="order-detail-box">
          <div className="box-title">{t('menu.label.info')}</div>
          <div className="box-contents" style={{ paddingTop: 0 }}>
            <List className="menu-list">
              {orderStore.liteOrder.menus.map((menu, index) => (
                <ListItem className="menu-detail" key={index}>
                  {/* 메뉴 */}
                  <Grid container>
                    <Grid item container direction="row">
                      <Grid item xs style={{ paddingRight: '5px' }}>
                        <Typography style={{ fontSize: '14px', fontWeight: 'bold' }}>{menu.name}</Typography>
                      </Grid>

                      <Grid item xs={1}>
                        <Typography align="center">
                          <b>x{menu.qty}</b>
                        </Typography>
                      </Grid>
                      <Grid item xs={4} style={{ textAlign: 'right' }}>
                        <CurrencyDisplay amount={menu.amt} size="small" />
                      </Grid>
                    </Grid>

                    {/* 토핑 */}
                    {menu.toppingGroups && menu.toppingGroups.length > 0 && (
                      <Grid item container direction="column">
                        {menu.toppingGroups.map(
                          toppingGroup =>
                            toppingGroup.toppings &&
                            toppingGroup.toppings.map((topping, toppingIndex) => (
                              <Grid item container direction="row" key={toppingIndex}>
                                <Grid
                                  item
                                  xs
                                  display="flex"
                                  style={{ alignItems: 'center', fontSize: '12px', color: '#9D9B9B' }}
                                >
                                  {`${toppingGroup.name} (${topping.name})`}
                                </Grid>
                                <Grid item xs={4} style={{ textAlign: 'right' }}>
                                  <CurrencyDisplay amount={topping.addPrice} size="small" fontWeight="normal" />
                                </Grid>
                              </Grid>
                            )),
                        )}
                      </Grid>
                    )}

                    {/* 세트 메뉴 */}
                    {menu.setMenuGroups && menu.setMenuGroups.length > 0 && (
                      <Grid item container direction="column">
                        {menu.setMenuGroups.map(
                          setMenuGroup =>
                            setMenuGroup.setMenus &&
                            setMenuGroup.setMenus.map((setMenu, setMenuIndex) => (
                              <Grid item container direction="row" key={setMenuIndex}>
                                <Grid
                                  item
                                  xs
                                  display="flex"
                                  style={{ alignItems: 'center', fontSize: '12px', color: '#9D9B9B' }}
                                >
                                  {`${setMenuGroup.name} (${setMenu.name})`}
                                </Grid>
                                <Grid item xs={4} style={{ textAlign: 'right' }}>
                                  <CurrencyDisplay amount={setMenu.addPrice} size="small" fontWeight="normal" />
                                </Grid>
                              </Grid>
                            )),
                        )}
                      </Grid>
                    )}
                  </Grid>
                </ListItem>
              ))}
              {cartStore.cartData.receiveMethodCode === ReceiveMethodEnum.DELIVERY && (
                <ListItem className="menu-detail">
                  {/* 메뉴 */}
                  <Grid container>
                    <Grid item container direction="row">
                      <Grid item xs style={{ paddingRight: '5px' }}>
                        <Typography style={{ fontSize: '14px', fontWeight: 'bold' }}>
                          {t('order.label.DeliveryFee')}
                        </Typography>
                      </Grid>

                      {/* <Grid item xs={1}>
                          <Typography align="center">
                            <b>x{menu.qty}</b>
                          </Typography>
                        </Grid> */}
                      <Grid item xs={4} style={{ textAlign: 'right' }}>
                        <CurrencyDisplay
                          amount={Number(menuStore.storeData.deliveryFee)}
                          size="small"
                          fontWeight="normal"
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </ListItem>
              )}
              {orderStore.usePoint > 0 && userStore.userPoint >= menuStore.storeData.useableMinimumPoint && (
                <ListItem className="menu-detail">
                  {/* 메뉴 */}
                  <Grid container>
                    <Grid item container direction="row">
                      <Grid item xs style={{ paddingRight: '5px' }}>
                        <Typography style={{ color: 'red', fontSize: '14px', fontWeight: 'bold' }}>
                          {t('payment.label.point')}
                        </Typography>
                      </Grid>
                      <Grid item xs={4} style={{ color: 'red', textAlign: 'right' }}>
                        <CurrencyDisplay amount={Number(orderStore.usePoint)} size="small" minus />
                      </Grid>
                    </Grid>
                  </Grid>
                </ListItem>
              )}
            </List>
            <Grid container direction="row" style={{ paddingTop: '16px' }}>
              <Grid item>
                <span style={{ fontSize: '18px', fontWeight: 'bold' }}>{t('payment.label.totalAmount')}</span>
              </Grid>
              <Grid item xs style={{ textAlign: 'right' }}>
                <CurrencyDisplay amount={orderStore.paymentAmount} type="emphasis" size="large" />
              </Grid>
            </Grid>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(withTranslation()(LiteMenuList));
